import React from "react";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import AuthState from "Context/Auth/AuthState";
import PrivateRoute from "Components/PrivateRoute";
import EditForm from "Pages/EditForm";
import Main from "Pages/Main";
import Login from "Pages/Login";
import CorrectionList from "Pages/CorrectionList";
import CorrectorEditorList from "Pages/CorrectorEditorList";
import EditUser from "Pages/EditUser";
import CorrectorRegister from "Pages/CorrectorRegister";
import CorrectionResult from "Pages/CorrectionResult";

const Routes = () => (
  <AuthState>
    <Router>
      <Switch>
        <Route exact path="/" component={Main} />
        <Route exact path="/login" component={Login} />
        <Route exact path="/corrector-register" component={CorrectorRegister} />
        <PrivateRoute exact path="/editlist" component={CorrectionList} />
        <PrivateRoute exact path="/editform" component={EditForm} />
        <PrivateRoute exact path="/edituser" component={EditUser} />
        <PrivateRoute
          path="/correctoreditorList/:id"
          exact
          component={CorrectorEditorList}
        />
        <Route exact path="/result/:id" component={CorrectionResult} />
      </Switch>
    </Router>
  </AuthState>
);

export default Routes;
